import React from 'react'
import './index.scss'

interface IProps {
  type: string;
  data: IHomeCustom;
}

const Custom: React.FC<IProps> = (props) => {
  const { type, data } = props
  const { materialType, materialUrl, link, phoneEnable, phone, width, height } = data

  const handleLink = () => {
    if (!link) return
    location.href = link
  }

  if (!materialUrl) return null

  const dpr = window.devicePixelRatio
  const isBrandStory = type === 'brandStory'
  return (
    <div className={`custom-wrapper${materialUrl ? '' : ' no-material'}`}>
      {
        materialType === 'img' && !!materialUrl && (
          isBrandStory ? (
            <>
              <img data-cypid='customJump' onClick={handleLink} src={materialUrl} className='custom-scale-item' style={{ width: `${dpr * 100}%`, transform: `scale(${1 / dpr})` }} />
              <img src={materialUrl} style={{ visibility: 'hidden' }} />
            </>
          ) : (
            <img data-cypid='customJump' onClick={handleLink} src={materialUrl} />
          )
        )
      }
      {materialType === 'video' && !!materialUrl && (
        <video
          id={`homeCustomVideo_${type}`}
          src={materialUrl}
          poster={`${materialUrl}?x-oss-process=video/snapshot,t_1000,m_fast`}
          controls
          loop
          muted
          playsInline
          webkit-playsinline='true'
          preload='auto'
        />
      )}
      {phoneEnable && !!materialUrl && <a className='custom-tel' href={`tel:${phone}`}><i className='iconfont icon-a-20'></i>{phone}</a>}
    </div>
  )
}

export default Custom
